import React from "react";

/** Slim section heading with bronze eyebrow + serif title */
export default function SectionHeader({ eyebrow, title, kicker, align = "left", className = "" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "text-left max-w-2xl"} ${className}`}>
      {eyebrow && <p className="eyebrow rise">{eyebrow}</p>}
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.05] tracking-tight rise rise-delay-1">
        {title}
      </h2>
      {kicker && (
        <p className="text-[var(--twr-warm-white)]/70 mt-5 text-base leading-relaxed rise rise-delay-2">
          {kicker}
        </p>
      )}
      <div className={`hairline mt-8 ${align === "center" ? "mx-auto max-w-[80px]" : "max-w-[80px]"}`} />
    </div>
  );
}
